module.exports = __webpack_public_path__ + "img/DW365-009.fb11810f.jpg";